import { Typography } from 'components/typography/typography-component';
import Image from 'next/image';
import Link from 'next/link';

const ReactSquadAdBanner = () => {
  return (
    <div className="relative flex flex-col bg-yellow px-6 pb-12 pt-6 md:sticky md:top-6">
      <Image
        src="/assets/react_squad_logo.svg"
        alt="React Squad"
        width={132.07}
        height={29.84}
        className=" object-contain "
      />

      <Typography
        variant="h3"
        className="mb-2 mt-6 max-w-72 font-LondrinaSolid text-4xl font-black text-black"
      >
        Hire <span className=" underline decoration-blue-500">reliable</span>{' '}
        React Developers without breaking the bank
      </Typography>

      <ul className="text-md mx-4 my-4  list-disc ">
        <li>
          <Typography className="font-LondrinaSolid font-thin">
            zero-risk replacement guarantee
          </Typography>
        </li>{' '}
        <li>
          <Typography className="font-LondrinaSolid font-thin">
            flexible monthly payments
          </Typography>
        </li>{' '}
        <li>
          <Typography className="font-LondrinaSolid font-thin">
            7-day free trial
          </Typography>
        </li>
      </ul>

      <Link href="/reactsquad">
        <button className=" hover:text-md mt-2 w-full transform border border-gray-900 bg-blue-600 px-2 py-3 font-LexendDeca text-sm text-white shadow-reactsquad transition-transform hover:scale-105 xsm:w-32 2xsm:w-44 sm:w-72 md:p-4 lg:w-48  ">
          Match me with a dev
        </button>
      </Link>

      <Image
        src="/assets/mascot.svg"
        alt="React Squad"
        width={170}
        height={101}
        className=" absolute bottom-0 right-0 hidden w-32 object-contain xsm:block 2xsm:w-40  sm:w-80 lg:hidden lg:w-36 xl:block "
      />
    </div>
  );
};

export default ReactSquadAdBanner;
